import Loadable from '../../components/loadable';

const ArchivedWorkoutsList = Loadable({
  loader: () => import('../../pages/workouts/archived_workouts_list/archived_workout_list'),
  type: 'block',
});

angular.module('gym').value('ArchivedWorkoutsList', ArchivedWorkoutsList);

const UnarchiveWorkoutModal = Loadable({
  loader: () => import('../../pages/workouts/archived_workouts_list/unarchive_workout_modal'),
  type: 'modal',
});

angular.module('gym').value('UnarchiveWorkoutModal', UnarchiveWorkoutModal);

const WorkoutDetailsModal = Loadable({
  loader: () => import('../../pages/workouts/archived_workouts_list/workout_details_modal'),
  type: 'modal',
});

angular.module('gym').value('WorkoutDetailsModal', WorkoutDetailsModal);
